import { render, staticRenderFns } from "./Block5.vue?vue&type=template&id=5b100c58&scoped=true&"
import script from "./Block5.vue?vue&type=script&lang=js&"
export * from "./Block5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b100c58",
  null
  
)

export default component.exports